/*
 * @Author: Tina Huang
 * @Date: 2024-02-18 11:09:29
 * @LastEditors: HTT httishere0728@gmail.com
 * @LastEditTime: 2025-07-31 19:47:42
 * @Description:
 */
import { Routes, Route, HashRouter } from 'react-router-dom'
import './App.css'
import Nav from './components/Nav'
import Panel1 from './components/Panel-1'
import PanelMe from './components/Panel-me'
import PanelTemplate from './components/Panel-2'
import PanelFans from './components/Panel-fans'
import MyLayout from './components/Layout'
import TopPanel from '@/components/Top-Panel'
import TopAlert from './components/Top-Alert'
import {
  Libs,
  Logs,
  LibEdit,
  Picks,
  PickDetail,
  Vips,
  News,
  Admin,
  GetTemplate,
  VipBase,
  Dairy,
  VipTemplate,
  Search,
  MayDaySticker,
  Balance,
  ReceiptCreator,
  QASpace,
  QADetail,
  ObsidianSpace,
  BlShop
} from './pages/index'
import { ConfigProvider } from 'antd'
import themeJSON from './theme/theme.json'

export const metadata = {
  title: 'Widverse · 汪汪汪世界',
  description: '原创Notion组件库 - HTTISHERE（阿汪同学）原创',
}

const combineElemment = (element: any, location: string) => {
  return (
    <MyLayout location={location}>
      <div className="p-3 sm:p-5 sm:pl-12 sm:pr-12">{element}</div>
    </MyLayout>
  )
}

function Home() {
  // useEffect(() => {
  //   console.log(searchParams)
  //   if (searchParams?.get('anchor') === 'comments') {
  //     const _top = document.getElementById('comments')?.offsetTop || 0
  //     document.body.scrollTop = _top
  //   }
  // }, [searchParams])
  return (
    <>
      <TopAlert hide={true} />
      {/* <TopPanel /> */}
      <PanelMe />
      <Nav />
      <Panel1 />
      <PanelTemplate />
      <PanelFans />
    </>
  )
}

function App() {
  return (
    <ConfigProvider theme={themeJSON}>
      <HashRouter>
        <Routes>
          <Route path="/" element={combineElemment(<Home />, '')} />
          <Route path="/vips" element={combineElemment(<Vips />, 'vips')} />
          {/* <Route path="/vips/period/:type?" element={combineElemment(<SpaceByType />, 'vips')} /> */}
          <Route path="/libs" element={combineElemment(<Libs />, 'libs')} />
          <Route path="/libs/:id" element={combineElemment(<LibEdit />, 'libs')} />
          <Route path="/logs" element={combineElemment(<Logs />, 'logs')} />
          <Route path="/notices" element={combineElemment(<News />, 'notices')} />
          <Route path="/picks/:tab?" element={combineElemment(<Picks />, 'picks')} />
          <Route path="/search/:keywords?" element={combineElemment(<Search />, 'search')} />
          <Route path="/vpicks" element={combineElemment(<Picks __type="vip" />, 'vip-picks')} />
          <Route path="/picks-detail/:id/:code?" element={combineElemment(<PickDetail />, 'picks')} />
          <Route path="/vpicks-detail/:id/:code?" element={combineElemment(<PickDetail from="vip" />, 'picks')} />
          <Route path="/admin-htt" element={combineElemment(<Admin />, 'admin')} />
          <Route path="/get-template/:code?" element={combineElemment(<GetTemplate />, 'admin')} />
          <Route path="/get-template-vip/:code?" element={combineElemment(<VipTemplate />, 'admin')} />
          <Route path="/how-to-balance/:id?" element={combineElemment(<Balance />, 'balance')} />
          {/* <Route path="/world" element={combineElemment(<World />, 'world')} /> */}
          <Route path="/vip/base" element={<VipBase />} />
          <Route path="/receipt-creator" element={combineElemment(<ReceiptCreator />, 'receipt')} />
          <Route path="/admin/dairy" element={<Dairy />} />
          <Route path="/mayday" element={<MayDaySticker />} />
          <Route path="/qa" element={combineElemment(<QASpace />, 'qa')} />
          <Route path="/qa/:id" element={combineElemment(<QADetail />, 'qa-detail')} />
          <Route path="/obsidian" element={combineElemment(<ObsidianSpace />, 'obsidian')} />
          <Route path="/shop-unlock/:id?" element={combineElemment(<BlShop />, 'bilibili')} />
        </Routes>
      </HashRouter>
    </ConfigProvider>
  )
}

export default App
